import { CypressI } from 'interfaces/cypress';
import { InputProps } from '@/interfaces';
import clsx from 'clsx';
import { ErrorMessageInput, Icon } from '@/components/common';
export const Textarea: React.FC<
	InputProps & CypressI & React.TextareaHTMLAttributes<HTMLTextAreaElement>
> = ({
	id,
	dataCY,
	name,
	title,
	register,
	rules,
	iconRight,
	iconLeft,
	rightClick,
	leftClick,
	customPlaceholder,
	onChangeCustom,
	error,
	rows = 5,
	markAsRequired,
	resizable,
	className,
	classNameInput,
	classNameIcon,
	classNameTitle,
	classNameContainer,
	classNameContainerInput,
	textAreaRef,
	autoResize,
	...props
}) => {
	const registerAux = register(name, rules);
	return (
		<div className={clsx('relative flex flex-col', className)}>
			<div className={clsx('relative group', classNameContainer)}>
				<label
					htmlFor={id || name}
					className={clsx(
						'block text-base text-left relative mb-2',
						error ? 'text-status-error-solid' : 'text-black',
						classNameTitle
					)}
				>
					<span className="relative">
						{title}
						{markAsRequired && (
							// <Asterisk className="w-3 h-3 absolute -right-3 top-0 text-red-500" />
							<span className="text-main-red absolute -right-3 top-0">*</span>
						)}
						{props.additionalInfoTitle && (
							<span className="text-opacity-black">
								{' '}
								{props.additionalInfoTitle}
							</span>
						)}
					</span>
				</label>
				<div
					className={clsx(
						'block border rounded-[32px] bg-white pr-4 overflow-hidden',
						{
							'group-hover:bg-[#F4F4F4A3]': props.disabled,
						},
						{
							'border-main-red': error,
						},
						classNameContainerInput
					)}
				>
					<textarea
						id={id || name}
						data-cy={dataCY}
						name={name}
						placeholder={customPlaceholder}
						rows={rows}
						className={clsx(
							{ 'px-6': !iconLeft && !iconRight },
							{ 'pl-14 pr-4': iconLeft },
							{ 'pl-6 pr-8': iconRight },
							'mt-2 placeholder-opacity-primary text-base py-3 w-full font-sans scroll-custom',
							'focus:outline-none focus:ring-offset-transparent',
							'disabled:placeholder-dark-40 disabled:cursor-not-allowed disabled:text-opacity-primary bg-transparent',
							{
								'focus:ring-black text-black border-opacity-primary': !error,
							},
							{
								'text-main-red': error,
							},
							{
								'resize-none': !resizable,
							},
							classNameInput
						)}
						ref={(el) => {
							// Your custom ref (textAreaRef)
							if (textAreaRef && 'current' in textAreaRef) {
								textAreaRef.current = el;
							}

							// React Hook Form's ref (registerAux.ref)
							const formRef = registerAux?.ref;
							if (typeof formRef === 'function') {
								formRef(el);
							}
						}}
						onChange={(e) => {
							if (autoResize) {
								e.target.style.height = 'auto';
								e.target.style.height = e.target.scrollHeight + 'px';
							}
							registerAux && registerAux.onChange(e);
							onChangeCustom && onChangeCustom(e);
						}}
						{...props}
					/>
				</div>

				{iconLeft && (
					<div
						onClick={leftClick}
						className={clsx('absolute left-4 top-[55%] w-6 h-6', classNameIcon)}
					>
						<Icon src={iconLeft} className="text-dark-80 cursor-pointer" />
					</div>
				)}
				{iconRight && (
					<div
						onClick={rightClick}
						className={clsx(
							'absolute right-4 top-[55%] w-6 h-6',
							classNameIcon
						)}
					>
						<Icon src={iconRight} className="cursor-pointer" />
					</div>
				)}
			</div>
			{error && error.message && <ErrorMessageInput message={error.message} />}
		</div>
	);
};
